import set from 'lodash/set';
import state from 'store/state/courier';
import types from 'store/types/courier';

const initialState = state;

export default (state = initialState, action) => {
  const { key, data, error } = action;

  switch (action.type) {
    case types.COURIER_SET:
      set(state, key, data);
      return { ...state };
    default:
      return state;
  }
};
